import { defineStore } from 'pinia';
import { Theme } from '@/types/general';

type Profile = {
  communication: {
    languageCode: string;
    locale: string;
    myPicture: string;
    nickName: string;
    noAdvertisements: boolean;
    noNewsletters: boolean;
  };
  theme: Theme;
  amountVisible: boolean;
};

export const useProfileStore = defineStore('profile', {
  state: (): Profile => ({
    communication: {
      languageCode: '',
      locale: '',
      myPicture: '',
      nickName: '',
      noAdvertisements: true,
      noNewsletters: true
    },
    theme: Theme.LIGHT_THEME,
    amountVisible: false
  }),
  getters: {
    getTheme: (state) => {
      return state.theme;
    },
    isAmountVisible: (state) => {
      return state.amountVisible;
    }
  },
  actions: {
    setProfile(profile: Profile) {
      this.communication = profile.communication;
    },
    setLanguage(locale: string) {
      this.communication.locale = locale;
    },
    setTheme(theme: Theme) {
      this.theme = theme;
    },
    setAmountVisible(visible: boolean) {
      this.amountVisible = visible;
    }
  }
});
